import { TAliasProps } from '../../AliasContainer';
import AliasAddModal from './AliasAddModal';
import AliasDeleteModal from './AliasDeleteModal';
import AliasEditModal from './AliasEditModal';

const AliasModalView = (props: TAliasProps) => (
    <>
        <AliasAddModal {...props} />
        <AliasEditModal {...props} />
        <AliasDeleteModal {...props} />
    </>
);

export default AliasModalView;
